export const W9_BACKUP_WITHHOLDING_TOOLTIP =
  'Most customers are not subject to IRS backup withholding; a customer may be subject if the IRS has notified them of an incorrect TIN or unreported interest/dividends.';

export const W9_CERTIFICATION_TOOLTIP =
  'For U.S. persons, resident aliens, and orgs with U.S. residency. The customer certifies, under penalty of perjury, that the TIN provided is correct and whether they are subject to IRS backup withholding.';

export const W9_EXEMPT_PAYEE_TOOLTIP = 'Applies to certain organizations. See Form W-9 instructions.';

export const W9_FOREIGN_OWNERS_TOOLTIP = 'Applies to certain partnership organizations. See Form W-9 instructions.';

export const W9_SIGNED_MORE_THAN_A_YEAR_AGO_TOOLTIP = 'This W-9 was signed over a year ago.';
